import React from 'react'
import PropTypes from 'prop-types'
import { AVAILABLE_BRANDS } from 'styles/theme'
import { useTheme } from 'styled-components'
import * as S from './styled'

const Layout1 = props => {
  const { color } = useTheme()
  if (color === AVAILABLE_BRANDS.CLOUD_LIGHT) {
    return <S.StyledLayoutLight {...props} />
  }
  if (color === AVAILABLE_BRANDS.CLOUD_DARK) {
    return <S.StyledLayoutDark {...props} />
  }
}

Layout1.defaultProps = {
  content: {},
}

Layout1.propTypes = {
  content: PropTypes.object,
}

export default Layout1
